import Aside from "../../components/Aside"
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import { ContactService } from "../../services/contactService"
import { useEffect, useMemo, useState } from "react"
import HandleNoData from "../../components/HandleNoData"
import EmptyState from "../../components/EmptyState"
import ContactFormModal from "./ContactFormModal"
import { useForm } from "react-hook-form"
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

function ContactHomePage() {
  
    const defaultValues = {
        term: ''
    }
    const { register, watch } = useForm({
        mode: 'onChange',
        defaultValues
    });
    const { term } = watch();
    
    const [contactsOriginal, setContactsOriginal] = useState([])
    const [contacts, setContacts] = useState([])
    const [modal, setModal] = useState({
        show: false,
        data: null
    })

    const optInTotal = useMemo(() => contactsOriginal.filter(c => c.opt_in_accepted ).length, [contactsOriginal]);
    const optInDeclinedTotal = useMemo(() => contactsOriginal.filter(c => c.opt_in_accepted === false ).length, [contactsOriginal]);
    const optInPendingTotal = useMemo(() => contactsOriginal.filter(c => c.opt_in_accepted === undefined ).length, [contactsOriginal]);
    
    const showModal = (data?: any) => {
        let contact = null;

        if(data) {
            contact = {
                _id: data._id,
                first_name: data.first_name,
                last_name: data.last_name,
                email: data.email,
                country_code: data.phones && data.phones.length ? data.phones[0].phone.country_code: '',
                phone_number: data.phones && data.phones.length ? data.phones[0].phone.phone_number: '',
                assigned_id: data.assigned_id?._id || '',
                segmentations: data.segmentations.map( (s: any) => s._id),
                type: data.type,
                medical_specialty: data?.medical_specialty?._id || ''
            }
        }        

        setModal({
            show: true,
            data: contact
        })
    }

    const getContacts = async () => {
        const response = await ContactService.getContacts()
        setContacts(response)
        setContactsOriginal(response)
    }

    const handleHideModal = async(refresh: boolean) => {
        if(refresh) {
            await getContacts();
        }

        setModal({
            show: false, 
            data: null
        })
    }

    const exportData = () => {
        const data = contacts.map( c => ({
            "_id": c._id ,
            "Nombre(s)": c.first_name ,
            "Apellido": c.last_name ,
            "Correo": c.email ,
            "Teléfono": c.phones && c.phones.length > 0 && (c.phones[0].phone.country_code + ' ' + c.phones[0].phone.phone_number),
            "Ruta": c.assigned_id ? c.assigned_id.name: '-',
            "Estatus Opt-In": c.opt_in_accepted ? 'Otorgado' : (c.opt_in_accepted === false ? 'No otorgado': 'No solicitado') ,
        }))
    

        // 1. Crear una hoja (worksheet) desde los datos
        const worksheet = XLSX.utils.json_to_sheet(data);
    
        // 2. Crear un libro (workbook) y agregar la hoja
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Contactos");
    
        // 3. Generar el archivo en binario
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    
        // 4. Crear un Blob y descargarlo
        const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(dataBlob, "projecter-contactos.xlsx");
      };
    

    useEffect(() => {
        getContacts()
    }, [])


    useEffect(() => {
      if (!term) {
        setContacts(contactsOriginal);
      } else {
        const  normalize = (str?: string): string => {
            return str
              ? str
                  .normalize("NFD") // Descompone caracteres como "é" en "e" + tilde
                  .replace(/[\u0300-\u036f]/g, "") // Elimina los signos diacríticos
                  .toLowerCase()
              : '';
          }

        const lowerSearch = term.toLowerCase();

        const filteredList = contactsOriginal.filter((record) => {
            const firstName = normalize(record.first_name);
            const lastName = normalize(record.last_name);
            const email = normalize(record.email);
            const specialty = normalize(record.medical_specialty?.name);
            const phone = normalize(record.phones?.[0]?.phone?.phone_number);
            const assignedId = normalize(record.assigned_id?.name);
            const opt_in_accepted = record.opt_in_accepted === undefined ? 'no solicitado': (record.opt_in_accepted ? 'otorgado': 'no otorgado')

          return (
            firstName.includes(lowerSearch) ||
            lastName.includes(lowerSearch) ||
            email.includes(lowerSearch) ||
            specialty.includes(lowerSearch) ||
            phone.includes(lowerSearch) ||
            assignedId.includes(lowerSearch) ||
            opt_in_accepted.includes(lowerSearch)
          );
        });

        setContacts(filteredList);
      }
    }, [term]);


    return (
        <>
            <Header>
                <div>
                    <h4>Contactos</h4>
                    <p>Administra y añade nuevos contactos</p>
                </div>

                <div className="ms-auto">
                    <button type="button" className="btn btn-soft-success btn-sm me-3" onClick={exportData}>descargar <i className="bi bi-download m-l-8"></i></button>
                    <button type="button" className="btn btn-primary btn-sm" onClick={() => showModal()}>nuevo contacto <i className="bi bi-plus-circle-fill m-l-8"></i></button>
                </div>
            </Header>

            <Aside />

            <main role="main" className="main">

                <div className="bg-white border-bottom">
                    <div className="container p-t-12 p-b-12 px-5">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-search m-l-8"></i>
                            <input className="form-control input-group-borderless form-control-flush" type="text" placeholder="Buscar" {...register('term')} />
                        </div>
                    </div>
                </div>

                <div className="content container px-5">

                    <div className='col-12 m-b-24'>
                        <div className="card ">
                            <div className="card-body d-flex">
                                <div className='mx-4 text-center flex-grow-1 '>
                                    <h3 className="text-center">{contacts.length}</h3>
                                    <p className='nowrap'>Total contactos </p>
                                </div>
                                <div className='border-lg-end'></div>
                                <div className='mx-4 text-center flex-grow-1 '>
                                    <h3 className="text-center">{optInPendingTotal}</h3>
                                    <p className='nowrap'>Sin solicitud de OPT-IN </p>
                                </div>
                                <div className='border-lg-end'></div>
                                <div className='mx-4 text-center flex-grow-1 '>
                                    <h3 className="text-center">{optInTotal}</h3>
                                    <p className='nowrap'>OPT-IN Otorgado </p>
                                </div>
                                <div className='border-lg-end'></div>
                                <div className='mx-4 text-center flex-grow-1 '>
                                    <h3 className="text-center">{optInDeclinedTotal}</h3>
                                    <p className='nowrap'>OPT-IN No Otorgado </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <HandleNoData
                        condition={contacts.length}
                        emptyComponent={<EmptyState />}
                    >
                        <table className="card-table table">
                            <thead>
                                <tr>
                                    <th scope="col">NOMBRE y Correo electrónico</th>
                                    <th scope="col">Opt-In</th>
                                    <th scope="col">Tipo o Especialidad</th>
                                    <th scope="col">RUTA O ID</th>
                                    <th scope="col">Teléfono</th>
                                    <th scope="col">Segmentación</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    contacts.map((contact: any) => (
                                        <tr key={contact._id}>
                                            <td>
                                                <div className="d-flex ">
                                                    <span className="avatar avatar-sm avatar-primary avatar-circle">
                                                        <img className="avatar-img" src={contact.avatar} alt={contact.first_name + ' ' + contact.last_name} />
                                                    </span>
                                                    <div className="m-l-16">
                                                        <p className="fw-semibold text-dark">{contact.first_name} {contact.last_name}</p>
                                                        <p>{contact.email}</p>
                                                        
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                { contact.opt_in_accepted &&  <span className="badge bg-soft-primary text-primary ">Otorgado</span>}
                                                { contact.opt_in_accepted === false &&  <span className="badge bg-soft-danger text-dark ">No otorgado</span>}
                                                { contact.opt_in_accepted === undefined &&  <span className="badge bg-soft-warning text-dark ">No solicitado</span>}
                                            </td>
                                            <td>
                                                { contact.type === 'OTHER' && 'Otro' }
                                                { contact.type === 'PHARMACY' && 'Farmacia' }
                                                { contact.type === 'DOCTOR' && contact?.medical_specialty?.name }
                                            </td>
                                            <td>{contact.assigned_id ? contact.assigned_id.name: <span className="badge bg-soft-danger text-dark">Sin asignar</span>}</td>
                                            <td>
                                                {
                                                    contact.phones && contact.phones.length > 0 && (contact.phones[0].phone.country_code + ' ' + contact.phones[0].phone.phone_number)
                                                }
                                            </td>
                                            <td>
                                                {
                                                    contact.segmentations.map((segment: any) => segment.title).join(', ')
                                                }
                                            </td>
                                            <td>
                                                {/* <button type="button" className="btn btn-outline-primary btn-outline-trash  btn-icon ">
                                                    <i className="bi bi-trash-fill"></i>
                                                </button> */}
                                                <button type="button" className="btn btn-outline-primary btn-outline-edit btn-icon m-l-8" onClick={() => showModal(contact)}>
                                                    <i className="bi bi-pencil-fill"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>

                    </HandleNoData>
                </div>

                <Footer />
            </main>


            <ContactFormModal show={modal.show} data={modal.data} onRequestClose={handleHideModal}  />

        </>
    )
}

export default ContactHomePage